/**
 * Deterministic category → color palette for the Sort runner.
 * Known category names get hand-picked pairs; unknown/custom names fall
 * back to a stable hash-based lookup so the same string always renders
 * the same color across sessions and devices.
 */

const KNOWN = {
  animals:          { bg: "#FEF3C7", border: "#D97706", text: "#92400E" }, // amber
  foods:            { bg: "#FEE2E2", border: "#DC2626", text: "#991B1B" }, // rose
  vehicles:         { bg: "#DBEAFE", border: "#2563EB", text: "#1E40AF" }, // blue
  objects:          { bg: "#D1FAE5", border: "#059669", text: "#065F46" }, // emerald
  clothes:          { bg: "#E9D5FF", border: "#7C3AED", text: "#5B21B6" }, // violet
  clothing:         { bg: "#E9D5FF", border: "#7C3AED", text: "#5B21B6" },
  kitchen:          { bg: "#FFEDD5", border: "#EA580C", text: "#9A3412" }, // orange
  bathroom:         { bg: "#CFFAFE", border: "#0891B2", text: "#155E75" }, // cyan
  "living room":    { bg: "#F3E8FF", border: "#9333EA", text: "#6B21A8" },
  "body parts":     { bg: "#FCE7F3", border: "#DB2777", text: "#9D174D" }, // pink
  colors:           { bg: "#E0F2FE", border: "#0284C7", text: "#075985" },
  shapes:           { bg: "#FEF9C3", border: "#CA8A04", text: "#854D0E" },
  feelings:         { bg: "#FFE4E6", border: "#E11D48", text: "#9F1239" },
  actions:          { bg: "#DCFCE7", border: "#16A34A", text: "#166534" },
  "school supplies":{ bg: "#E0E7FF", border: "#4F46E5", text: "#3730A3" }, // indigo
  "household items":{ bg: "#F5F5F4", border: "#57534E", text: "#292524" }, // stone
  "fine motor":     { bg: "#FBCFE8", border: "#DB2777", text: "#831843" },
  "gross motor":    { bg: "#BAE6FD", border: "#0369A1", text: "#0C4A6E" },
  "wh questions":   { bg: "#F1F5F9", border: "#334155", text: "#0F172A" }, // slate
  "echoic sounds":  { bg: "#FEF3C7", border: "#B45309", text: "#78350F" },
  "oral motor":     { bg: "#FDE68A", border: "#B45309", text: "#78350F" },
  "fill-ins":       { bg: "#E0F2FE", border: "#0369A1", text: "#0C4A6E" },
  uncategorized:    { bg: "#F1F5F9", border: "#94A3B8", text: "#334155" },
};

const FALLBACK_PALETTE = [
  { bg: "#FEF3C7", border: "#D97706", text: "#92400E" },
  { bg: "#DBEAFE", border: "#2563EB", text: "#1E40AF" },
  { bg: "#D1FAE5", border: "#059669", text: "#065F46" },
  { bg: "#FEE2E2", border: "#DC2626", text: "#991B1B" },
  { bg: "#E9D5FF", border: "#7C3AED", text: "#5B21B6" },
  { bg: "#FFEDD5", border: "#EA580C", text: "#9A3412" },
  { bg: "#CFFAFE", border: "#0891B2", text: "#155E75" },
  { bg: "#FCE7F3", border: "#DB2777", text: "#9D174D" },
];

function hashString(str) {
  let h = 0;
  for (let i = 0; i < str.length; i += 1) {
    h = (h << 5) - h + str.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h);
}

export function categoryColor(name) {
  const key = (name || "Uncategorized").trim().toLowerCase();
  if (KNOWN[key]) return KNOWN[key];
  return FALLBACK_PALETTE[hashString(key) % FALLBACK_PALETTE.length];
}
